import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "rank-history-edit",
  components: {
    AppHeader
  },
  async created() {
    await this.getRankHistory();
    await this.getUser();
    this.getTodayDate();
  },
  data() {
    return {
      canChoiceYears: [],
      dayCount: "",
      changeYear: "",
      changeMonth: "",
      changeDay: "",
      rankHistory: {
        user_id: "",
        change_date: "",
        one_evaluation: "",
        two_evaluation: "",
        three_evaluation: "",
        rank: "",
        content: ""
      },
      user: ""
    };
  },
  computed: {
    changeDateFormat() {
      return dayjs(
        `${this.changeYear}-${this.changeMonth}-${this.changeDay}`
      ).format("YYYY-MM-DD");
    },
    changeDateBeforeToday() {
      if (this.changeYear && this.changeMonth && this.changeDay) {
        if (this.changeDateFormat <= dayjs().format("YYYY-MM-DD")) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  },
  methods: {
    async getUser() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_USER", {
          id: this.rankHistory.user_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.user = res.user;
    },
    getTodayDate() {
      let today = new Date();
      let currentYear = today.getFullYear();
      for (let i = 0; i < 60; i++) {
        this.canChoiceYears.push(currentYear - i);
      }
      this.dayCount = new Date(this.changeMonth, this.changeDay, 0).getDate();
    },
    async getRankHistory() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_RANK_HISTORY", {
          id: this.$route.params.rank_history_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.rankHistory.user_id = res.rank_history.user_id;
      this.changeYear = parseInt(res.rank_history.change_date.substr(0, 4));
      this.changeMonth = parseInt(res.rank_history.change_date.substr(5, 2));
      this.changeDay = parseInt(res.rank_history.change_date.substr(8, 2));
      this.rankHistory.one_evaluation = res.rank_history.one_evaluation;
      this.rankHistory.two_evaluation = res.rank_history.two_evaluation;
      this.rankHistory.three_evaluation = res.rank_history.three_evaluation;
      this.rankHistory.rank = res.rank_history.rank;
      this.rankHistory.content = res.rank_history.content;
    },
    async editRankHistory() {
      this.rankHistory.change_date = this.changeDateFormat;
      let data = this.rankHistory;
      let res = await this.$store
        .dispatch("EDIT_RANK_HISTORY", {
          id: this.$route.params.rank_history_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.goRankHistory();
      }
    },
    goUserDetail() {
      this.$router.push({ path: `/user/${this.rankHistory.user_id}` });
    },
    goRankHistory() {
      this.$router.push({ path: `/rank_history/${this.rankHistory.user_id}` });
    },
    getDayCount() {
      this.changeDay = "";
      this.dayCount = new Date(this.changeYear, this.changeMonth, 0).getDate();
    }
  }
};
